<template>
  <div class="big-box">
    <div class="scroll-box">
      <img :src="backgroundImage" alt="" class="big-box-img" />
      <div class="big-body">
        <img :src="tapTopUrl" alt="" class="tap-top" />
        <div class="pd8">
          <!-- 主题文字 -->
          <div
            class="theme-word"
            :style="`color: ${customerPaperwork.titleColor};`"
          >
            <div class="title">{{ customerPaperwork.title }}</div>
            <div class="desc">{{ customerPaperwork.desc }}</div>
          </div>
          <img :src="cardUrl" alt="打卡记录图" class="card-img" />
          <div class="card-box">
            <template v-if="!ruleDTO.isAddBuyItem">
              <div class="card-nav" v-if="navList.length > 0">
                <div
                  :class="['nav-item', { 'active-box': index == currentIndex }]"
                  @click="getCurrentIndex(index, item)"
                  :style="`width: ${100 / navList.length}%`"
                  v-for="(item, index) in navList"
                >
                  {{ item.cardText }}
                </div>
              </div>
              <div v-else class="card-nav"></div>
              <div
                :class="[
                  'card-content',
                  {
                    'active-content': currentIndex == 0,
                    'active-content2':
                      currentIndex > 0 && currentIndex < navList.length - 1,
                    'active-content3': currentIndex == navList.length - 1,
                  },
                ]"
              >
                <div class="prize-item" v-for="item in prizeList">
                  <div class="logo-box">
                    <img
                      v-if="item.logo"
                      :src="item.logo"
                      alt=""
                      class="logo-img"
                    />
                    <div class="card-mock">
                      <span>{{ currentCardText }}</span>
                      <span v-if="currentCardType == 2">{{
                        item.calenderCheckCardSpecifiedDate
                      }}</span>
                      <span
                        v-else-if="currentCardType == 3 || currentCardType == 4"
                        >{{ item.calenderCheckCardTimes }}</span
                      >
                      <span>打卡可得</span>
                    </div>
                  </div>
                  <div>
                    <div class="prize-title">{{ item.title }}</div>
                    <div class="prize-total">剩余{{ item.totalAmount }}份</div>
                    <div>
                      <costomPreviwBtn
                        class="win-box"
                        :btnUrl="btnUrl"
                        :btnSize="btnSize"
                        btnText="领取该奖品"
                        :isShowDynamicIcon="false"
                        :btnTextStyle="btnTextStyle"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </template>
            <template v-else>
              <div class="goods-box">
                <div class="shop-box">
                  <div class="shop-title">店铺推荐</div>
                  <div class="export-logo">
                    <img
                      v-if="firstItemList.length > 0"
                      :src="firstItemList[0].logo"
                      alt=""
                    />
                  </div>
                  <div class="export-name" v-if="firstItemList.length > 0">{{ firstItemList[0].title }}</div>
                  <div class="export-btn">加入购物车</div>
                </div>
                <div class="prize-content">
                  <div class="prize-header">
                    <img
                      src="https://cdn-image.yucrm.cn/images/dyAssets/images/preview/jd-left-icon.png"
                      alt="左图标"
                      @click="previewClick"
                      class="preview-img"
                    />
                    <div>{{ currentCardText }}打卡</div>
                    <img
                      src="https://cdn-image.yucrm.cn/images/dyAssets/images/preview/jd-right-icon.png"
                      alt="右图标"
                      @click="nextClick"
                      class="next-img"
                    />
                  </div>
                  <div class="prize-wrap" v-for="item in prizeList">
                    <div class="prize-wrap_item">
                      <div class="goods-wrap">
                        <img :src="item.logo" alt="" />
                        <div class="goods-mock">
                          <span v-if="currentCardType != 2">{{
                            currentCardText
                          }}</span>
                          <span v-if="currentCardType == 2">{{
                            item.calenderCheckCardSpecifiedDate
                          }}</span>
                          <span
                            v-else-if="
                              currentCardType == 3 || currentCardType == 4
                            "
                            >{{ item.calenderCheckCardTimes }}</span
                          >
                          <span>打卡可得</span>
                        </div>
                      </div>
                      <div>
                        <div class="goods-title">{{ item.title }}</div>
                        <div class="goods-total">
                          剩余{{ item.totalAmount }}份
                        </div>
                        <div class="win-btn">
                          <costomPreviwBtn
                            :btnUrl="exportBtnUrl"
                            :btnSize="exportBtnSize"
                            btnText="领取该奖品"
                            :isShowDynamicIcon="false"
                            :btnTextStyle="btnTextStyle"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </div>
          <div class="card-sign">
            <img
              src="https://tbplustest.yusms.com/img/everyDayChickIn.90a6c160.png"
              alt=""
            />
          </div>
        </div>
        <img class="resign-task" src="https://cdn-image.yucrm.cn/images/dyAssets/images/preview/jd-resign-task.svg" alt="">
        <div class="main-btn">
          <costomPreviwBtn
            :btnUrl="participateUrl"
            :btnSize="participateBtnSize"
            btnText="立即打卡"
            dynamicUrl="https://cdn-image.yucrm.cn/images/jd-front-platform/images/preview/sweep-light.svg"
            :btnTextStyle="participateBtnTextStyle"
          />
        </div>
      </div>
    </div>
    <div class="footer-title">图为预览效果，以实际投效果为准</div>
  </div>
</template>
<script>
import costomPreviwBtn from "@/views/interactiveMarketing/activity/components/commCustomizationSet/costomPreviwBtn.vue";
export default {
  name: "",
  components: {
    costomPreviwBtn,
  },
  mixins: [],
  props: {
    ruleForm: {
      type: Object,
      default: () => ({}),
    },
    ruleDTO: {
      type: Object,
      default: () => ({}),
    },
    customerPaperwork: {
      type: Object,
      default: () => ({}),
    },
    templateObj: {
      type: Object,
      default: () => ({}),
    },
    backgroundImage: {
      type: String,
      default: "",
    },
    oneTimeList: {
      type: Array,
      default: () => [],
    },
    dayTimeList: {
      type: Array,
      default: () => [],
    },
    specifiedDateList: {
      type: Array,
      default: () => [],
    },
    cumulativeCheckiInList: {
      type: Array,
      default: () => [],
    },
    continuousCheckInList: {
      type: Array,
      default: () => [],
    },
    firstItemList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      currentCardType: 0,
      prizeList: [],
      currentIndex: 0,
      tapTopUrl:
        "https://cdn-image.yucrm.cn/images/dyAssets/images/preview/shop_top.png",
      btnSize: {
        width: "65px",
        height: "23px",
      },
      exportBtnSize: {
        width: "63px",
        height: "17px",
      },
      participateBtnSize: {
        width: "214px",
        height: "36px",
      },
    };
  },
  computed: {
    tabUrl() {
      return this.customerPaperwork.tabUrl
        ? this.customerPaperwork.tabUrl
        : this.templateObj.url3;
    },
    btnUrl() {
      return this.customerPaperwork.url4
        ? this.customerPaperwork.url4
        : this.templateObj.url4;
    },
    exportBtnUrl() {
      return this.customerPaperwork.url5
        ? this.customerPaperwork.url5
        : this.templateObj.url5;
    },
    btnTextStyle() {
      return {
        fontSize: "10px",
        color: this.customerPaperwork.prizeBtnColor || "#fff",
      };
    },
    cardUrl() {
      return this.customerPaperwork.url3
        ? this.customerPaperwork.url3
        : this.templateObj.url3;
    },
    navList() {
      const cardTypes = {
        0: "单次有礼",
        1: "每日有礼",
        2: "指定有礼",
        3: "累计有礼",
        4: "连续有礼",
      };
      const list = this.ruleDTO.signTypes
        .sort((a, b) => a - b)
        .map((item) => {
          return {
            cardText: cardTypes[item] || "",
            cardType: item,
          };
        });
      return list;
    },
    currentCardText() {
      const types = {
        0: "单次",
        1: "每日",
        2: "指定",
        3: "累计",
        4: "连续",
      };
      return types[this.currentCardType] || "";
    },
    participateUrl() {
      return this.customerPaperwork.url2
        ? this.customerPaperwork.url2
        : this.templateObj.url2;
    },
    participateBtnTextStyle() {
      return {
        fontSize: "12px",
        color: this.customerPaperwork.signBtnColor || "#fff",
      };
    },
  },
  watch: {
    navList: {
      handler(newVal, oldVal) {
        if(newVal.length>0) {
          this.getCurrentIndex(0, newVal[0]);
        }
      },
      immediate: true,
      deep: true,
    },
  },
  mounted() {},
  beforeDestroy() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
  methods: {
    previewClick() {
      if(this.currentIndex <= 0) {
        return;
      } else {
        this.currentIndex--;
      this.getCurrentIndex(this.currentIndex, this.navList[this.currentIndex]);
      }
   
    },
    nextClick() {
      if(this.currentIndex >= this.navList.length - 1) {
        return;
      } else {
        this.currentIndex++;
        this.getCurrentIndex(this.currentIndex, this.navList[this.currentIndex]);
      }
    },
    // 获取当前选中的索引
    getCurrentIndex(index, item) {
      this.currentCardType = item.cardType;
      this.currentIndex = index;
      const listMap = {
        0: this.oneTimeList,
        1: this.dayTimeList,
        2: this.specifiedDateList,
        3: this.cumulativeCheckiInList,
        4: this.continuousCheckInList,
      };
      this.prizeList = listMap[item.cardType] || [];
    },
    // 将十六进制颜色转换为rgba格式，支持透明度设置，透明度不影响子元素
    hexToRgba(hex, opacity) {
      if (!hex) return "rgba(255,255,255,1)";
      // 处理简写形式 #fff => #ffffff
      let color = hex.replace("#", "");
      if (color.length === 3) {
        color = color[0] + color[0] + color[1] + color[1] + color[2] + color[2];
      }
      const r = parseInt(color.substring(0, 2), 16);
      const g = parseInt(color.substring(2, 4), 16);
      const b = parseInt(color.substring(4, 6), 16);
      const a = opacity / 100;
      return `rgba(${r}, ${g}, ${b}, ${a})`;
    },
    // 将颜色变浅，amount 0-1，0不变，1变白
    lightenColor(hex, amount) {
      if (!hex) return "#EBEBEB";
      let color = hex.replace("#", "");
      if (color.length === 3) {
        color = color[0] + color[0] + color[1] + color[1] + color[2] + color[2];
      }
      const num = parseInt(color, 16);
      const r = Math.min(
        255,
        Math.floor((num >> 16) + (255 - (num >> 16)) * amount)
      );
      const g = Math.min(
        255,
        Math.floor(
          ((num >> 8) & 0x00ff) + (255 - ((num >> 8) & 0x00ff)) * amount
        )
      );
      const b = Math.min(
        255,
        Math.floor((num & 0x0000ff) + (255 - (num & 0x0000ff)) * amount)
      );
      return `rgb(${r}, ${g}, ${b})`;
    },
  },
};
</script>
<style lang="scss" scoped>
.big-box {
  position: relative;
  width: 300px;
  height: 580px;
  box-shadow: 0px 4px 20px 0px rgba(18, 10, 60, 0.15);
  border-radius: 24px;
  border: 1px solid #ffffff;
  padding: 8px;
  margin-left: 231px;
  z-index: 999;
  background-color: #ffffff;

  .scroll-box {
    position: relative;
    width: 284px;
    height: 560px;
    overflow: hidden;
    border-radius: 24px;
    &::-webkit-scrollbar {
      width: 0px;
      height: 0px;
    }
  }

  .big-box-img {
    border-radius: 24px;
    width: 100%;
  }
  .big-body {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    .tap-top {
      width: 100%;
    }
    .pd8 {
      width: 100%;
      height: 100%;
      margin-top: 20px;
      box-sizing: border-box;
      position: relative;
      .theme-word {
        // position: absolute;
        display: flex;
        flex-direction: column;
        align-items: center;
        // top: 18px;
        width: 100%;
        > div:first-child {
          height: 16px;
          font-weight: bold;
          font-size: 15px;
          margin-bottom: 10px;
        }
        > div:last-child {
          margin: 0 auto;
          text-align: center;
          width: 65%;
          height: 11px;
          line-height: 12px;
          font-size: 11px;
          opacity: 0.7;
        }
      }
      .card-img {
        position: absolute;
        top: 0;
        left: 10px;
        width: 37px;
        height: 37px;
        object-fit: cover;
      }
      .card-box {
        width: 266px;
        height: 136px;
        position: absolute;
        top: 65px;
        left: 50%;
        padding: 6px;
        transform: translateX(-50%);
        .card-nav {
          height: 27px;
          display: flex;
          align-items: center;
          .nav-item {
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 10px;
            color: #766c56;
            line-height: 27px;
            text-align: center;
            font-style: normal;
            text-transform: none;
            text-align: center;
          }
          .active-box {
            background-color: rgba(255, 255, 255, 0.9);
            border-radius: 4px 4px 0px 0px;
          }
          .active-box2 {
            background-color: rgba(255, 255, 255, 0.9);
            border-radius: 4px 4px 0px 4px;
          }
        }
        .card-content {
          display: flex;
          width: 100%;
          height: 95px;
          padding: 9px;
          background-color: rgba(255, 255, 255, 0.9);
          overflow: hidden;
        }
        .active-content {
          border-radius: 0px 4px 4px;
        }
        .active-content2 {
          border-radius: 4px;
        }
        .active-content3 {
          border-radius: 4px 0px 4px 4px;
        }
        .prize-item {
          margin-right: 10px;
          position: relative;
          display: flex;
          // align-items: center;
          .logo-box {
            position: relative;
            width: 80px;
            height: 80px;
            border-radius: 4px;
            margin-right: 7px;
            .logo-img {
              width: 100%;
              height: 100%;
              position: absolute;
              top: 0;
              left: 0;
            }
            .card-mock {
              position: absolute;
              width: 100%;
              padding: 2px;
              // height: 18px;
              left: 0;
              bottom: 0;
              background: rgba(0, 0, 0, 0.5);
              border-radius: 0px 0px 4px 4px;
              color: #ffffff;
              font-family: PingFang SC, PingFang SC;
              font-weight: 400;
              font-size: 9px;
              color: #ffffff;
              // line-height: 18px;
              text-align: center;
              font-style: normal;
              text-transform: none;
            }
          }
          .prize-title {
            width: 155px;
            max-height: 29px;
            font-family: PingFang SC, PingFang SC;
            font-weight: bold;
            font-size: 10px;
            color: #262626;
            text-align: left;
            font-style: normal;
            line-height: normal;
            text-transform: none;
            // 两行省略号
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
          }
          .prize-total {
            margin-top: 5px;
            font-family: PingFang SC, PingFang SC;
            font-weight: 400;
            font-size: 9px;
            color: #999999;
            line-height: normal;
            align-items: center;
            justify-content: center;
            justify-content: center;
            text-align: center;
            font-style: normal;
            text-transform: none;
            width: 50px;
            height: 13px;
            border-radius: 2px;
            border: 1px solid #e1e1e1;
            // 一行省略号
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          .win-box {
            position: absolute;
            bottom: 0;
            right: 5px;
          }
        }
        .goods-box {
          display: flex;
          justify-content: center;
          align-items: center;
          .shop-box {
            margin-right: 10px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            .shop-title {
              font-family: PingFang SC, PingFang SC;
              font-weight: bold;
              font-size: 11px;
              color: #1a1a1a;
              line-height: 11px;
              text-align: center;
              font-style: normal;
              text-transform: none;
            }
            .export-logo {
              margin-top: 7px;
              width: 66px;
              height: 66px;
              border-radius: 4px;
              img {
                width: 100%;
                height: 100%;
                object-fit: cover;
                border-radius: 4px;
              }
            }
            .export-name {
              margin: 3px 0;
              width: 69px;
              font-family: PingFang SC, PingFang SC;
              font-weight: 400;
              font-size: 9px;
              color: #262626;
              text-align: center;
              font-style: normal;
              text-transform: none;
              // 一行省略号
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            .export-btn {
              width: 47px;
              height: 13px;
              border-radius: 2px;
              border: 1px solid #333333;
              font-family: PingFang SC, PingFang SC;
              font-weight: 400;
              font-size: 8px;
              color: #333333;
              line-height: normal;
              display: flex;
              justify-content: center;
              align-items: center;
              text-align: center;
              font-style: normal;
              text-transform: none;
            }
          }
          .prize-content {
            padding: 7px;
            width: 168px;
            height: 124px;
            background: linear-gradient(
              180deg,
              rgba(255, 255, 255, 0.4) 0%,
              #ffffff 100%
            );
            border-radius: 6px;
            border: 1px solid #ffffff;
            overflow: hidden;
            .prize-header {
              position: relative;
              display: flex;
              justify-content: space-between;
              align-items: center;
              .preview-img,
              .next-img {
                width: 13px;
                height: 13px;
              }
            }

            .prize-wrap {
              margin-top: 9px;
              margin-bottom: 6px;
              &_item {
                display: flex;
                align-items: center;
                flex-shrink: 0;
                .goods-wrap {
                  position: relative;
                  width: 66px;
                  height: 66px;
                  border-radius: 4px;
                  margin-right: 7px;
                  img {
                    position: absolute;
                    top: 0;
                    left: 0;
                    width: 100%;
                    height: 100%;
                  }
                  .goods-mock {
                    position: absolute;
                    width: 100%;
                    padding: 2px;
                    // height: 18px;
                    left: 0;
                    bottom: 0;
                    background: rgba(0, 0, 0, 0.5);
                    border-radius: 0px 0px 4px 4px;
                    color: #ffffff;
                    font-family: PingFang SC, PingFang SC;
                    font-weight: 400;
                    font-size: 9px;
                    color: #ffffff;
                    // line-height: 18px;
                    text-align: center;
                    font-style: normal;
                    text-transform: none;
                  }
                }
                .goods-title {
                  width: 84px;
                  max-height: 28px;
                  font-family: PingFang SC, PingFang SC;
                  font-weight: bold;
                  font-size: 10px;
                  color: #262626;
                  text-align: left;
                  font-style: normal;
                  text-transform: none;
                  line-height: normal;
                  // 两行省略号
                  overflow: hidden;
                  text-overflow: ellipsis;
                  display: -webkit-box;
                  -webkit-line-clamp: 2;
                  -webkit-box-orient: vertical;
                }
                .goods-total {
                  margin-top: 5px;
                  font-family: PingFang SC, PingFang SC;
                  font-weight: 400;
                  font-size: 9px;
                  color: #999999;
                  line-height: normal;
                  text-align: center;
                  font-style: normal;
                  text-transform: none;
                  width: 50px;
                  height: 13px;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  justify-content: center;
                  border-radius: 2px;
                  border: 1px solid #e1e1e1;
                  // 一行省略号
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                }
                .win-btn {
                  margin-top: 5px;
                }
              }
            }
          }
        }
      }

      .card-sign {
        position: absolute;
        top: 210px;
        left: 50%;
        transform: translateX(-50%);
        width: 261px;
        height: 350px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .flex-c {
        display: flex;
        align-items: center;
        justify-content: center;
      }
      .flex-box {
        display: flex;
        align-items: center;
      }
    }
    .main-btn {
      position: absolute;
      left: 13%;
      bottom: 20px;
    }
    .resign-task {
      width: 41px;
      height: 41px;
      position: absolute;
      right: 10px;
      bottom: 60px;

    }
  }
  .footer-title {
    width: 100%;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    margin-top: 30px;
    font-size: 14px;
    font-weight: 400;
    color: #999999;
    line-height: 14px;
    text-align: center;
  }
  .mt7 {
    margin-top: 7px;
  }
  .ml2 {
    margin-left: 2px;
  }
  .flex-box {
    display: flex;
  }
}
</style>
